/* eslint-disable import/prefer-default-export */
import { takeLatest, put, call, all } from 'redux-saga/effects' // eslint-disable-line
import getDisabledUsersActions, {
    getDisabledUsersTypes,
} from '../../../redux/user/getDisabledUsers'
import { Get } from '../../../serveur/axios'

function* getDisabledUsersSagas() {
    try {
        const res = yield Get(`users/all-agents?enable=true`)
        if (res.status === 200) {
            yield put(getDisabledUsersActions.getDisabledUsersSuccess(res.data))
        } else {
            yield put(getDisabledUsersActions.getDisabledUsersFailure(res.data))
        }
    } catch (error) {
        yield put(getDisabledUsersActions.getDisabledUsersFailure(error))
    }
}

export function* getDisabledUsersSaga() {
    yield takeLatest(
        getDisabledUsersTypes.GET_DISABLED_USERS_REQUEST,
        getDisabledUsersSagas
    )
}
